import { render, staticRenderFns } from "./UserDashboardNotice.vue?vue&type=template&id=1135c5d0&scoped=true&"
import script from "./UserDashboardNotice.vue?vue&type=script&lang=js&"
export * from "./UserDashboardNotice.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardNotice.vue?vue&type=style&index=0&id=1135c5d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1135c5d0",
  null
  
)

export default component.exports